import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsInterviewIncentiveBannerEnabled() {
  return useCbhFlag(CbhFeatureFlag.INTERVIEW_INCENTIVE_BANNER_ENABLED, {
    defaultValue: false,
  });
}
